module.exports = __webpack_public_path__ + "fonts/nunito-extrabold.1a99fe9.woff";